module.exports = __webpack_public_path__ + "static/img/5.b82e4ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/global/5.png
// module id = Aa2B
// module chunks = 1